import React from 'react';
import "../../scss/layout/Nav.scss";

const Nav = ({manufactures, handleClick, ...props }) => {
    return (
        <nav className="nav nav--primary">
            {manufactures.full_name.map((v, i) => {
                const shortName = manufactures.shortend_name[i];
                return (
                    <div className="nav__item" key={i} data-shortname={shortName} onClick={handleClick}>
                        {v}
                    </div>
                )
            })}
        </nav>
    )
}

export default Nav;